import { hasWebpVersion, getWebpBackgroundImage } from "../components/Picture/webpUtils";

function replacer (match:string) {
    const url = match.match(/\((.*?)\)/)[1].replace(/('|")/g,'');
    if (url && hasWebpVersion(url))  return getWebpBackgroundImage(url);

    return match;
}

export function parseCss(css: string) {
    const bgImageMatch = /background-image: *url\((.*?)\);?/g;
    const replacedCss = css.replace(bgImageMatch, replacer);

    return replacedCss.replace(/\n/g, '').replace(/\s\s+/g, ' ');
}
